import React, { createContext, useState, useEffect, useMemo } from "react";
import { getAllLocations } from "../../utils/services/Master/getAllLocations";
import { useValidToken } from "../../hooks/useValidToken";

export const LocationContext = createContext();

export const LocationProvider = ({ children }) => {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const { isValid, authLoading, user } = useValidToken();

  const fetchLocations = async () => {
    if (authLoading || !isValid) return;

    try {
      const data = await getAllLocations();
      setLocations(data);
    } catch (error) {
      console.error("Error fetching locations:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLocations();
  }, [authLoading, isValid]);

  // Datos del usuario actual desde el login
  const userLocation = user?.location || null;
  const userRole = user?.rol || null;
  const userEmployeeId = user?.employee || null;

  // Calcular el locationId del usuario automáticamente
  const userLocationId = useMemo(() => {
    if (!userLocation || locations.length === 0) return null;
    const location = locations.find(
      (loc) => loc.center.toLowerCase() === userLocation.toLowerCase()
    );
    return location ? location.locationId : null;
  }, [userLocation, locations]);

  // Datos completos de la location del usuario
  const userLocationData = useMemo(() => {
    if (!userLocation || locations.length === 0) return null;
    return locations.find(
      (loc) => loc.center.toLowerCase() === userLocation.toLowerCase()
    ) || null;
  }, [userLocation, locations]);

  // Helper function to get locationId by center name
  const getLocationIdByCenter = (centerName) => {
    if (!centerName || locations.length === 0) return null;
    const location = locations.find(
      (loc) => loc.center.toLowerCase() === centerName.toLowerCase()
    );
    return location ? location.locationId : null;
  };

  // Helper function to get full location data by center name
  const getLocationByCenter = (centerName) => {
    if (!centerName || locations.length === 0) return null;
    return locations.find(
      (loc) => loc.center.toLowerCase() === centerName.toLowerCase()
    ) || null;
  };

  return (
    <LocationContext.Provider value={{
      // Lista de todas las locations
      locations,
      loading,
      // Datos del usuario actual
      userLocation,
      userLocationId,
      userLocationData,
      userRole,
      userEmployeeId,
      // Helper functions
      getLocationIdByCenter,
      getLocationByCenter
    }}>
      {children}
    </LocationContext.Provider>
  );
};
